var exports = {
  "K": "CodeElements.module__icon___akhMWH",
};

module.exports = exports;
